import { VirtualKanbanColumn } from "./VirtualKanbanColumn";
import { WeekView } from "./WeekView";
import { DayView } from "./DayView";
import { motion } from "motion/react";
import React from "react";
import { TicketInterface } from "../../../../models/TicketModule/Ticket";
import { StatusInterface } from "../../../../models/TicketModule/Status";
import { ViewMode } from "../KanbanBoardPage";

interface KanbanBoardProps {
  tickets: TicketInterface[];
  statuses: StatusInterface[];
  viewMode: ViewMode;
  currentWeekStart: Date;
  onTicketMove: (ticketId: string, newStatusId: string) => void;
  selectedDay?: Date;
  onDayChange?: (day: Date) => void;
  selectedStatuses: string[];
  darkMode: boolean;
  ticketsByStatus: Map<string, TicketInterface[]>;
  rangeStart?: Date;
  rangeEnd?: Date;
}

function KanbanBoardComponent({
  tickets,
  statuses,
  viewMode,
  currentWeekStart,
  onTicketMove,
  selectedDay,
  onDayChange,
  selectedStatuses,
  darkMode,
  ticketsByStatus,
  rangeStart,
  rangeEnd,
}: KanbanBoardProps) {
  const visibleStatuses = statuses;

  if (viewMode === "week" || viewMode === "board") {
    return (
      <WeekView
        tickets={tickets}
        statuses={visibleStatuses}
        currentWeekStart={currentWeekStart}
        onTicketMove={onTicketMove}
        darkMode={darkMode}
        rangeStart={rangeStart}
        rangeEnd={rangeEnd}
        useCustomRange={viewMode === "board"}
      />
    );
  }

  if (viewMode === "day" && selectedDay && onDayChange) {
    return (
      <DayView
        tickets={tickets}
        statuses={visibleStatuses}
        currentWeekStart={currentWeekStart}
        selectedDay={selectedDay}
        onDayChange={onDayChange}
        onTicketMove={onTicketMove}
        darkMode={darkMode}
      />
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex-1 overflow-x-auto bg-gradient-to-br from-slate-50 via-white to-slate-50"
    >
      <div className=" p-5" style={{ backgroundColor: darkMode ? "#555880" : "transparent" }}>
        <div className="flex gap-4 h-full" style={{ paddingBottom: 10 }}>
          {visibleStatuses.map((status, index) => {
            const columnTickets = ticketsByStatus.get(status.id || "") || [];
            return (
              <motion.div
                key={status.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.08 }}
                className="flex-1 min-w-[320px] max-w-[380px] bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
                style={{ height: "fit-content" }}
              >
                <VirtualKanbanColumn
                  status={status}
                  tickets={columnTickets}
                  count={columnTickets.length}
                  onTicketMove={onTicketMove}
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </motion.div>
  );
}
export const KanbanBoard = React.memo(KanbanBoardComponent);
